import { TextField } from "@mui/material";
import React from "react";
import { red } from "../assets/colors";

function CustomTextField(props) {
	{
		return props.regular ? (
			<>
				<TextField
					variant="outlined"
					disabled={props?.disabled}
					type = {props?.type ? props.type : null}
					fullWidth
					multiline={props.isMultiLine}
					rows={props.isMultiLine ? props?.rows ? props.rows : 4 : undefined}
					placeholder={props.placeHolder ? props.placeHolder : ""}
					value={props.value ? props.value : ""}
					InputProps={{
						style: {
							height: props.isMultiLine ? "" : "2rem",
							padding: props?.isMultiLine ? "0.5rem": "0.2rem",
							paddingLeft: props?.isMultiLine ? "0.5rem" : "0rem",
							boxShadow: "0 0.2rem 0.4rem 0 #D3D3D3",
						},
						sx: {
							fontSize: "0.9rem",
						},
					}}
					InputLabelProps={{
						sx: { fontSize: "1rem" },
					}}
					onChange={(e) => {
						props.indexRequired ?
						props.setFunc(props.id, e.target.value) :
						props.setFunc(e.target.value);
					}}
				></TextField>
			</>
		) : (
			<>
				<TextField
					// variant="outlined"
					disabled={props?.disabled}
					type = {props?.type ? props.type : null}
					multiline={props.isMultiline}
					rows={props.isMultiLine ? 4 : undefined}
					maxRows={props.isMultiLine ? 4 : undefined}
					// fullWidth
					placeholder={props.placeHolder ? props.placeHolder : ""}
					value={props.value ? props.value : ""}
					InputProps={{
						sx: {
							fontSize: "0.9rem",
							"& .MuiInputBase-input": {
								padding: props.isMultiline ? "0.2rem" : "0rem",
								paddingLeft: props.isMultiline ? "0.2rem" : "0.5rem",
								paddingRight: props.isMultiline ? "0.2rem" : "0.5rem",
								height: props.isMultiline ? "auto" : '2rem',
							},
						},
						style: {
							// height: props.isMultiLine ? undefined : "2rem",
							// minHeight: props.isMultiLine ? "auto" : undefined,
							width: props.width ? props.width : null,
							// padding: "0.2rem",
							// paddingLeft: props.isMultiLine ? "0.5rem" :"0rem",
							boxShadow: "0 0.2rem 0.4rem 0 #D3D3D3",
						},
					}}
					InputLabelProps={{
						sx: { fontSize: "1rem" },
					}}
					onChange={(e) => {
						
						if( props.indexReq){
							props.setFunc(props.options, e.target.value)
						} else 
						{props.setFunc(e.target.value);}
					}}
					onKeyDown={(e) =>  e.stopPropagation()}
				></TextField>
			</>
		);
	}
}

export default CustomTextField;
